// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__OnEUL","fullpage":"loading_fullpage__i8vx1","spinner":"loading_spinner__-+7IQ","spin":"loading_spin__OW+R2"};